import './App.css';
import AlpacaApp from './component/AlpacaApp';

function App() {
  return <AlpacaApp></AlpacaApp>
}

export default App;
